import React, { useState } from 'react';
import { Camera, X, Maximize2, Sparkles } from 'lucide-react';

export default function GallerySection() {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryItems = [
    {
      id: 1,
      src: '/assets/usmazu-banner-test-02.jpg',
      titleZh: '美國媽祖基金會主橫幅',
      titleEn: 'American Mazu Foundation Header Banner',
      category: 'Banner'
    },
    {
      id: 2,
      src: '/assets/MAZU.jpg',
      titleZh: '湄洲分靈媽祖聖像',
      titleEn: 'Goddess Mazu Consecrated Statue',
      category: 'Deity'
    },
    {
      id: 3,
      src: '/assets/cropped-mazu-cover-page-270x270.jpg',
      titleZh: '媽祖開光大典封面',
      titleEn: 'Mazu Consecration Cover Photo',
      category: 'Event'
    },
    {
      id: 4,
      src: '/assets/cropped-mazu-cover-page-192x192.jpg',
      titleZh: '媽祖巡遊慶典集錦',
      titleEn: 'Mazu Parade Celebration Photo',
      category: 'Parade'
    },
    {
      id: 5,
      src: '/assets/cropped-mazu-cover-page-180x180.jpg',
      titleZh: '紐約法拉盛香格里拉會館',
      titleEn: 'Flushing Shangri-La Building Temple',
      category: 'Temple'
    }
  ];

  return (
    <div className="max-w-6xl mx-auto px-4 py-8 space-y-10">
      
      {/* Title */}
      <div className="text-center space-y-3 border-b border-gray-200 pb-6">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-50 text-[#8B0000] border border-red-200 text-xs font-semibold">
          <Camera className="w-3.5 h-3.5" />
          Gallery 盛事圖庫
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[#8B0000] font-serif">
          媽祖開光與巡遊盛況圖冊
        </h1>
        <p className="text-gray-500 font-mono text-sm">
          Mazu Parade 2016 & Historic Consecration Celebration Photos
        </p>
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {galleryItems.map((item) => (
          <div 
            key={item.id}
            onClick={() => setSelectedImage(item)}
            className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all cursor-pointer group flex flex-col justify-between"
          >
            <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
              <img 
                src={item.src} 
                alt={item.titleZh}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <span className="text-white text-xs font-semibold flex items-center gap-1">
                  <Maximize2 className="w-3.5 h-3.5" /> 點擊放大觀看 View Full Image
                </span>
              </div>
              <div className="absolute top-3 left-3 bg-[#8B0000] text-white text-[10px] uppercase font-mono px-2.5 py-1 rounded-full font-bold shadow">
                {item.category}
              </div>
            </div>

            <div className="p-4 bg-white border-t border-gray-100">
              <h3 className="text-base font-bold text-gray-900 font-serif group-hover:text-[#8B0000] transition-colors">
                {item.titleZh}
              </h3>
              <p className="text-xs text-gray-500 font-sans mt-0.5">
                {item.titleEn}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Photo Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div 
            className="relative max-w-4xl w-full bg-white rounded-2xl p-4 sm:p-6 shadow-2xl space-y-4"
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 text-gray-700 hover:text-red-700 p-2 rounded-full bg-gray-100 hover:bg-gray-200 z-10"
              aria-label="Close"
            >
              <X className="w-6 h-6" />
            </button>

            <div className="max-h-[75vh] flex items-center justify-center bg-gray-50 rounded-xl overflow-hidden p-2 border border-gray-200">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.titleZh} 
                className="max-h-[70vh] w-auto object-contain rounded-lg"
              />
            </div>

            <div className="flex justify-between items-center pt-2 border-t border-gray-200">
              <div>
                <h3 className="text-xl font-bold text-[#8B0000] font-serif">
                  {selectedImage.titleZh}
                </h3>
                <p className="text-sm text-gray-500">
                  {selectedImage.titleEn}
                </p>
              </div>
              <span className="bg-red-50 text-[#8B0000] border border-red-200 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                <Sparkles className="w-3.5 h-3.5" /> {selectedImage.category}
              </span>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
